import React, { useState } from 'react';
import { HiOutlineInformationCircle } from 'react-icons/hi';
import { FiPlusSquare } from 'react-icons/fi';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { FaRegMinusSquare } from "react-icons/fa";
import { FaRegEdit } from "react-icons/fa";
import Editbutton from '../Editbutton.jsx/Editbutton';
import HomeSuccessstoryeditbutton from '../HomeSuccessstoryedit/HomeSuccessstoryeditbutton';
import { Tooltip } from 'react-tooltip';


 const Homesuccessstorybutton = () => {
  const [openDropdown, setOpenDropdown] = useState(null); // null, 'one', or 'two'

  function getOrdinalSuffix(n) {
  const s = ["th", "st", "nd", "rd"],
    v = n % 100;
  return s[(v - 20) % 10] || s[v] || s[0];
}

  return (
  <div className="space-y-4 w-full">
  {/* Dropdown 1 */}
  <div className="w-full">
    {/* Header */}
   <div className="flex items-center gap-2 p-2 text-xl border-b border-gray-500">
    <span
      data-tooltip-id="successStoryTooltip"
      data-tooltip-html={`<div class='tooltip-bubble'>
          <div class='tooltip-content'>
            Add details about successful customers or use cases.<br/>
            Include stats, quotes, or any impactful story.
          </div>
          <div class='tooltip-tail'></div>
        </div>`}
      className="text-2xl mt-1 cursor-pointer"
    >
      <HiOutlineInformationCircle />
    </span>

    <h1>Add Success Story</h1>
     <FiPlusSquare
            className="text-blue-600 cursor-pointer"
            onClick={() => setOpenDropdown(openDropdown === 'one' ? null : 'one')}
          />
    <div
      className="cursor-pointer"
      onClick={() => setOpenDropdown(openDropdown === 'one' ? null : 'one')}
    >
      {openDropdown === 'one' ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
    </div>
  </div>

  {/* Tooltip instance */}
  <Tooltip
    id="successStoryTooltip"
    place="bottom"
    offset={10}
    className="!bg-transparent !p-0 !rounded-none z-30 ms-28"
  />


    {/* Dropdown Content with transition */}
  <div
  className={`transition-all duration-500 overflow-hidden text-sm w-full ${
    openDropdown === 'one'
      ? 'max-h-[230px] border border-gray-700 rounded-b-md rounded-t-md'
      : 'max-h-0 border-0'
  }`}
>

  {/* Horizontal Scroll Container */}
  <div className="overflow-x-auto w-full ">
    {/* Row with scrollable items */}
    <div className="flex flex-nowrap w-max gap-4 p-2">
  {[...Array(6)].map((_, i) => (
    <div key={i} className="p-3 min-w-[280px]">
      <div className="flex justify-between items-center mb-2">
        <h2 className="w-fit">{`${i + 1}${getOrdinalSuffix(i + 1)} Content`}</h2>
        <h1 className="text-blue-600 text-lg cursor-pointer mr-3 mt-1">
          <FaRegMinusSquare />
        </h1>
      </div>
      <div >
        <HomeSuccessstoryeditbutton/>
      </div>
    </div>
  ))}
</div>
  </div>
</div>

  </div>
</div>




  );
};
export default Homesuccessstorybutton;